import React from 'react';
import '../css/Services.css';

function Services() {
  return (
    <div className="services-container">
      <h1>Our Services</h1>
      <p>
        PortMatch simplifies your global shipping experience by combining technology, partnerships, and transparent pricing in one place.
      </p>
        <div className="services-list">
          <div className="service-card">Port-to-Port Freight Comparison</div>
          <div className="service-card">Dynamic Rate Insights</div>
          <div className="service-card">Real-Time Tracking & Status Updates</div>
          <div className="service-card">Partner Matching for Logistics Firms</div>
          <div className="service-card">Secure Booking & Billing</div>
          <div className="service-card">Route Optimization with AI</div>
          <div className="service-card">Account Management Tools</div>
      </div>
    </div>
  );
}

export default Services;
